import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL || '';

// const DEFAULT_REGIONS = [
//   { id: 'ch-zurich',     name: 'Switzerland (Zurich)',          flag: 'CH', primary: true,  status: 'active',  dataTypes: ['Claims', 'Policies', 'Client PII', 'Financial Records'], capacity: 78, compliance: ['FADP', 'FINMA', 'ISO 27001'] },
//   { id: 'ch-geneva',    name: 'Switzerland (Geneva) – DR',     flag: 'CH', primary: false, status: 'active',  dataTypes: ['Claims', 'Policies', 'Backups'],                           capacity: 32, compliance: ['FADP', 'ISO 27001'] },
//   { id: 'de-frankfurt', name: 'Germany (Frankfurt) – Archive', flag: 'DE', primary: false, status: 'standby', dataTypes: ['Audit Logs', 'Long-term Archive'],                         capacity: 15, compliance: ['GDPR', 'BSI IT-Grundschutz'] },
// ];

// const DEFAULT_CATEGORIES = [
//   { category: 'Client PII',        region: 'CH-ZH Primary', retention: '10 years', encryption: 'AES-256', lastAudit: '2025-01-15', status: 'compliant' },
//   { category: 'Claims Data',       region: 'CH-ZH Primary', retention: '7 years',  encryption: 'AES-256', lastAudit: '2025-01-15', status: 'compliant' },
//   { category: 'Policy Documents',  region: 'CH-ZH Primary', retention: '10 years', encryption: 'AES-256', lastAudit: '2025-01-15', status: 'compliant' },
//   { category: 'Financial Records', region: 'CH-ZH Primary', retention: '10 years', encryption: 'AES-256', lastAudit: '2025-01-15', status: 'compliant' },
//   { category: 'Audit Logs',        region: 'DE-FR Archive',  retention: '5 years',  encryption: 'AES-256', lastAudit: '2025-01-10', status: 'compliant' },
//   { category: 'Backups',           region: 'CH-GE DR',       retention: '90 days',  encryption: 'AES-256', lastAudit: '2025-01-12', status: 'review' },
// ];

const useDataResidencyFunctions = () => {
  const [activeTab, setActiveTab] = useState('overview');
  const [regions, setRegions] = useState([]);
  const [categories, setCategories] = useState([]);
  const [auditedAt, setAuditedAt] = useState('28 Feb 2025');
  const [allCompliant, setAllCompliant] = useState(true);
  const [auditRunning, setAuditRunning] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const [loading, setLoading] = useState(true);

  const tabs = [
    { id: 'overview', label: 'Data Regions' },
    { id: 'categories', label: 'Data Categories' },
    { id: 'transfers', label: 'Data Transfers' },
  ];

  const fetchConfig = useCallback(async () => {
    try {
      const resp = await axios.get(`${BASE_URL}/data-residency`, { withCredentials: true });
      const d = resp.data?.data;
      if (d) {
        if (d.regions?.length) setRegions(d.regions);
        if (d.dataCategories?.length) setCategories(d.dataCategories);
        if (d.auditedAt) setAuditedAt(new Date(d.auditedAt).toDateString());
        if (d.allCompliant !== undefined) setAllCompliant(d.allCompliant);
      }
    } catch {
      /* empty state on error */
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchConfig();
  }, [fetchConfig]);

  const handleRunAudit = async () => {
    setAuditRunning(true);
    try {
      const resp = await axios.post(`${BASE_URL}/data-residency/audit`, {}, { withCredentials: true });
      if (resp.data?.data?.auditedAt) {
        setAuditedAt(new Date(resp.data.data.auditedAt).toDateString());
        setAllCompliant(resp.data.data.allCompliant !== false);
      }
    } catch {
      /* ok */
    } finally {
      setAuditRunning(false);
    }
  };

  const handleDownloadReport = async () => {
    setDownloading(true);
    try {
      const resp = await axios.get(`${BASE_URL}/data-residency/compliance-report`, {
        withCredentials: true,
        responseType: 'blob',
      });
      const url = URL.createObjectURL(new Blob([resp.data], { type: 'text/plain' }));
      const a = document.createElement('a');
      a.href = url;
      a.download = `regure-data-residency-${Date.now()}.txt`;
      a.click();
      URL.revokeObjectURL(url);
    } catch {
      alert('Report download failed. Please try again.');
    } finally {
      setDownloading(false);
    }
  };
  return {
    activeTab,
    setActiveTab,
    regions,
    setRegions,
    categories,
    setCategories,
    auditedAt,
    setAuditedAt,
    allCompliant,
    setAllCompliant,
    auditRunning,
    setAuditRunning,
    downloading,
    setDownloading,
    loading,
    setLoading,
    tabs,
    fetchConfig,
    handleRunAudit,
    handleDownloadReport,
  };
};

export default useDataResidencyFunctions;
